<template>
  <TicketPage />
</template>

<script>
// @ is an alias to /src
import TicketPage from "@/components/TicketPage.vue";

export default {
  name: "TicketView",
  components: {
    TicketPage,
  },
};
</script>
